export const ErrorTypeEnum = {
  NONE: 'None',
  MISPRONUNCIATION: 'Mispronunciation',
  OMISSION: 'Omission',
  INSERTION: 'Insertion',
} as const;

export type ErrorTypeEnum = (typeof ErrorTypeEnum)[keyof typeof ErrorTypeEnum];

export interface PhonemeModel {
  phoneme?: string;
  bestPhoneme?: string;
  accuracyScore?: number;
  rangeTimeInSeconds?: [number, number];
}

export interface SyllableModel {
  syllable?: string;
  accuracyScore?: number;
  rangeTimeInSeconds?: [number, number];
}

export interface SpeechCorrectionModel {
  word?: string;
  accuracyScore?: number;
  errorType?: string;
  rangeTimeInSeconds?: [number, number];
  syllables?: SyllableModel[];
  phonemes?: PhonemeModel[];
  isPunctuation?: boolean;
}

export interface AssessmentConfigModel {
  enableMiscue?: boolean;
}
